import { useEffect, useState, Fragment, useContext } from "react";
import {PageTreeContext} from "../../context/pageTreeContext"
import { isNeitherNullNorUndefined } from "../../utils/functions";
import { Link, useNavigate } from 'react-router-dom';
import "./../../style/navbar.css"
import {imageBaseURL, categoryToIconMapper, KOMPASS_SVG_URL} from "../../constants"


export default function SideDRawerNavigation({isSidebarOPen, clickSomewhere}){
  const pageTreeContextValue = useContext(PageTreeContext);


//TODO: In Lerneinheiten noch keine pageTree info in der sidebar!!!

  useEffect(() => {
    //TODO: get pageTree in context if doesnt exist

  }, [])

  return (
    <div className={isSidebarOPen ? " sideDrawer " : " sideDrawer-closed "}>

      <div className="sideMenuClose ">
        <svg class="closeArrow w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"/>
        </svg>
        <img src={KOMPASS_SVG_URL} 
          width="70" onClick={clickSomewhere} alt="" 
        /> 
          
       </div>

      {isNeitherNullNorUndefined(pageTreeContextValue.pageNavigationInfo) 
      && isNeitherNullNorUndefined(pageTreeContextValue.getPageTree()) && pageTreeContextValue.getPageTree().map(lerneinheit => {
        return <div>
                  <div className="drawerExtraLargeText " > 
                  {
                    // {pageTreeContextValue.pageNavigationInfo.lerneinheitID === lerneinheit.uid ? "  " : ""} >
                  }
                    <Link to={"/lerneinheiten/page/" + lerneinheit.uid}>{lerneinheit.title}</Link>
                  </div>
                  <hr className="solid dividingLine"></hr>
                  <div className={ 
                    pageTreeContextValue.pageNavigationInfo.lerneinheitID 
                    && pageTreeContextValue.pageNavigationInfo.lerneinheitID === lerneinheit.uid 
                    ? 
                    "sidebar-accordeon-content-open " 
                    : 
                    "sidebar-accordeon-content"}>
                    {lerneinheit.subChapters.map(subChapter => {
                      return <div>
                               <div className={pageTreeContextValue.pageNavigationInfo.subChapterID === subChapter.uid ? "drawerLargeText sideDRawerSubChapterLink sideDRawerSubChapterLink-Active " : "drawerLargeText sideDRawerSubChapterLink"}> 
                                <Link to={"/lerneinheiten/page/" + subChapter.uid}>{subChapter.title}</Link>
                               </div>

                               <div className={ 
                                pageTreeContextValue.pageNavigationInfo.subChapterID 
                                && pageTreeContextValue.pageNavigationInfo.subChapterID === subChapter.uid 
                                ? 
                                "sidebar-accordeon-content-open-Inner " 
                                : 
                                "sidebar-accordeon-content"}
                                >
                                  {subChapter.leafPages.map(leafPage => {
                                  return <div className="pageTreeLeafItem ">
                                              <img src={leafPage.category[0] in categoryToIconMapper 
                                                ? 
                                                imageBaseURL + categoryToIconMapper[leafPage.category[0]] 
                                                :
                                                ""} 
                                                alt=""/>
                                              <div className={pageTreeContextValue.currentPageID === leafPage.uid 
                                                ? 
                                                "pageTreeLeafItemText activeSideDrawerItem " 
                                                : 
                                                "pageTreeLeafItemText "}>
                                                  <Link to={"/lerneinheiten/page/" + leafPage.uid}>{leafPage.title}</Link>
                                              </div>
                                            </div>
                                  })}
                              </div>
                          </div>
                  })}
                  </div>
              </div>
      })}


      
    </div>
  )
}